export default "https://a.travel-assets.com/partner-portal/error.05de66d7ce98.svg";